(function () {
  var bar = document.getElementById('fmd-sticky-bar');
  if (!bar) return;
  var hero = document.querySelector('.fmd-hero');
  var threshold = hero ? hero.offsetHeight : 400;
  var shown = false;

  // Match sticky bar height to header on mobile
  var header = document.getElementById('SiteHeader');
  if (header) {
    bar.style.setProperty('--header-h', header.offsetHeight + 'px');
  }

  window.addEventListener(
    'scroll',
    function () {
      var shouldShow = window.scrollY > threshold;
      if (shouldShow && !shown) {
        bar.classList.add('fmd-sticky-bar--visible');
        shown = true;
      } else if (!shouldShow && shown) {
        bar.classList.remove('fmd-sticky-bar--visible');
        shown = false;
      }
    },
    { passive: true },
  );
})();
